import { FC } from 'react';
import {ReactSVG} from "react-svg";
import close from '../assets/images/icons/close.svg';

interface Props {
  onClick: () => void;
  className?: string;
  style?: any;
}

const ModalClose: FC<Props> = ({onClick, className, style}) => {
  return (
    <div className={`modal-close ${ className || ''}`} onClick={onClick} style={style}>
      <ReactSVG src={close} className='react-icon'/>
    </div>
  );
};

export default ModalClose;
